<template>
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Progresso do Usuários</h6>
      <div class="ms-auto">
        <router-link
          to="/home"
          class="btn btn-outline-dark"
          title="Página Inicial"
        >
          Página Inicial
        </router-link>
      </div>
    </div>
    <ListUsersProgress
      :usersProgress="usersProgress"
      @getCoursesUser="getCoursesUser"
    />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import ListUsersProgress from '@/components/reports/ListUsersProgress.vue'

export default {
  name: 'UsersProgress',

  components: {
    LoadingData,
    ListUsersProgress,
  },

  data() {
    return {
      loadData: true,
      usersProgress: [],
    }
  },

  methods: {
    async getReportUsersProgress() {
      try {
        this.usersProgress = await this.$store.dispatch(
          'getReportUsersProgress',
        )

        /* this.usersProgress = await Promise.all(
          usersProgress.map(async (user) => {
            const courses = await this.getCoursesUser(user.id)
            return {
              ...user,
              courses,
            }
          }),
        ) */

        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getCoursesUser(userId) {
      try {
        const userIndex = this.usersProgress.findIndex(
          (user) => user.id === userId,
        )

        if (!this.usersProgress[userIndex].courses) {
          const courses = await this.$store.dispatch('getCoursesUser', userId)
          this.usersProgress[userIndex].courses = this.createContent(courses)
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createContent(courses) {
      let notStarted = ''
      let inProgress = ''
      let done = ''

      if (courses.notStarted.length > 0) {
        // eslint-disable-next-line prettier/prettier
        notStarted = `<ul class="list-group">${courses.notStarted.map((course) => `<li class="my-1">${course.name}</li>`).join('')}</ul>`
      }
      if (courses.inProgress.length > 0) {
        // eslint-disable-next-line prettier/prettier
        inProgress = `<ul class="list-group">${courses.inProgress.map((course) => `<li class="my-1">${course.name}</li>`).join('')}</ul>`
      }
      if (courses.done.length > 0) {
        // eslint-disable-next-line prettier/prettier
        done = `<ul class="list-group">${courses.done.map((course) => `<li class="my-1">${course.name}</li>`).join('')}</ul>`
      }

      return {
        notStarted,
        inProgress,
        done,
      }
    },
  },

  mounted() {
    this.getReportUsersProgress()
  },
}
</script>
